export const practicequestion = [
    {
        id: 1,
        questions: "https://i.ibb.co/VSnBcTq/pq1.jpg",
        answer: "https://i.ibb.co/1bZPwTJ/aq1.jpg"
    },
    {
        id: 2,
        questions: "https://i.ibb.co/6PJQyj9/pq2.jpg",
        answer: "https://i.ibb.co/pJXy8Y4/aq2.jpg"
    },
    {
        id: 3,
        questions: "https://i.ibb.co/VpF2rn8/pq3.jpg",
        answer: "https://i.ibb.co/qmnC3YF/aq3.jpg"
    },
    {
        id: 4,
        questions: "https://i.ibb.co/NWX0mYZ/pq4.jpg",
        answer: "https://i.ibb.co/r4F46J1/aq4.jpg"
    },
    {
        id: 5,
        questions: "https://i.ibb.co/0hVmyT6/pq5.jpg",
        answer: "https://i.ibb.co/JHnVgcq/aq5.jpg"
    },
    {
        id: 6,
        questions: "https://i.ibb.co/6FnqJhh/pq6.jpg",
        answer: "https://i.ibb.co/1qTkqv8/aq6.jpg"
    },
    {
        id: 7,
        questions: "https://i.ibb.co/fttGLXk/pq7.jpg",
        answer: "https://i.ibb.co/WB8506S/aq7.jpg"
    },
    {
        id: 8,
        questions: "https://i.ibb.co/gzPgJyC/pq8.jpg",
        answer: "https://i.ibb.co/qrV2ymM/aq8.jpg"
    },
    {
        id: 9,
        questions: "https://i.ibb.co/8YZwQ6s/pq9.jpg",
        answer: "https://i.ibb.co/QFnW3Mc/aq9.jpg"
    },
    {
        id: 10,
        questions: "https://i.ibb.co/jTm6dhC/pq10.jpg",
        answer: "https://i.ibb.co/rtVYG6B/aq10.jpg"
    }
]


export const easyquestion = [
    {
        id: 1,
        questions: "https://i.ibb.co/hVpfN2L/eq1.jpg",
        answer: 2
    },
    {
        id: 2,
        questions: "https://i.ibb.co/BVVSwwc/eq2.jpg",
        answer: 3
    },
    {
        id: 3,
        questions: "https://i.ibb.co/ryYR2zB/eq3.jpg",
        answer: 2
    },
    {
        id: 4,
        questions: "https://i.ibb.co/KyZJPYD/eq4.jpg",
        answer: 1
    },
    {
        id: 5,
        questions: "https://i.ibb.co/pQSxFHF/eq5.jpg",
        answer: 1
    },
    {
        id: 6,
        questions: "https://i.ibb.co/Cz4v5FF/eq6.jpg",
        answer: 1
    },
    {
        id: 7,
        questions: "https://i.ibb.co/WDB0Pzd/eq7.jpg",
        answer: 2
    },
    {
        id: 8,
        questions: "https://i.ibb.co/d0ZLB41/eq8.jpg",
        answer: 3
    },
    {
        id: 9,
        questions: "https://i.ibb.co/9YFNqKv/eq9.jpg",
        answer: 4
    },
    {
        id: 10,
        questions: "https://i.ibb.co/4fVh3LK/eq10.jpg",
        answer: 4
    }
]

export const mediumquestion = [
    {
        id: 1,
        questions: "https://i.ibb.co/8MBNzPp/mq1.jpg",
        answer: 4
    },
    {
        id: 2,
        questions: "https://i.ibb.co/Mg1sbb3/mq2.jpg",
        answer: 4
    },
    {
        id: 3,
        questions: "https://i.ibb.co/MBM672z/mq3.jpg",
        answer: 2
    },
    {
        id: 4,
        questions: "https://i.ibb.co/VYkPc6y/mq4.jpg",
        answer: 3
    },
    {
        id: 5,
        questions: "https://i.ibb.co/48XcL7r/mq5.jpg",
        answer: 3
    },
    {
        id: 6,
        questions: "https://i.ibb.co/4sXHKqW/mq6.jpg",
        answer: 1
    },
    {
        id: 7,
        questions: "https://i.ibb.co/0nVsn4T/mq7.jpg",
        answer: 3
    },
    {
        id: 8,
        questions: "https://i.ibb.co/vcB5DJ6/mq8.jpg",
        answer: 4
    },
    {
        id: 9,
        questions: "https://i.ibb.co/BCGCXWk/mq9.jpg",
        answer: 1
    },
    {
        id: 10,
        questions: "https://i.ibb.co/C6j5ZCn/mq10.jpg",
        answer: 3
    }
]

export const hardquestion = [
    {
        id: 1,
        questions: "https://i.ibb.co/p1Xz9cp/hq1.jpg",
        answer: 1
    },
    {
        id: 2,
        questions: "https://i.ibb.co/F5VvH3r/hq2.jpg",
        answer: 3
    },
    {
        id: 3,
        questions: "https://i.ibb.co/nnVWVbj/hq3.jpg",
        answer: 3
    },
    {
        id: 4,
        questions: "https://i.ibb.co/TTwR5P9/hq4.jpg",
        answer: 1
    },
    {
        id: 5,
        questions: "https://i.ibb.co/GHSSLYK/hq5.jpg",
        answer: 2
    },
    {
        id: 6,
        questions: "https://i.ibb.co/kyCKhnh/hq6.jpg",
        answer: 2
    },
    {
        id: 7,
        questions: "https://i.ibb.co/sRbZ05Z/hq7.jpg",
        answer: 2
    },
    {
        id: 8,
        questions: "https://i.ibb.co/gm1RdKw/hq8.jpg",
        answer: 3
    },
    {
        id: 9,
        questions: "https://i.ibb.co/vcVv1MG/hq9.jpg",
        answer: 2
    },
    {
        id: 10,
        questions: "https://i.ibb.co/76YnwYz/hq10.jpg",
        answer: 2
    }
]

let data = [
    {
        "id": 1,
        "questions": "https://i.ibb.co/hVpfN2L/eq1.jpg",
        "answer": 2
    },
    {
        "id": 2,
        "questions": "https://i.ibb.co/BVVSwwc/eq2.jpg",
        "answer": 3
    },
    {
        "id": 3,
        "questions": "https://i.ibb.co/ryYR2zB/eq3.jpg",
        "answer": 2
    },
    {
        "id": 4,
        "questions": "https://i.ibb.co/KyZJPYD/eq4.jpg",
        "answer": 1
    },
    {
        "id": 5,
        "questions": "https://i.ibb.co/pQSxFHF/eq5.jpg",
        "answer": 1
    },
    {
        "id": 6,
        "questions": "https://i.ibb.co/Cz4v5FF/eq6.jpg",
        "answer": 1
    },
    {
        "id": 7,
        "questions": "https://i.ibb.co/WDB0Pzd/eq7.jpg",
        "answer": 2
    },
    {
        "id": 8,
        "questions": "https://i.ibb.co/d0ZLB41/eq8.jpg",
        "answer": 3
    },
    {
        "id": 9,
        "questions": "https://i.ibb.co/9YFNqKv/eq9.jpg",
        "answer": 4
    },
    {
        "id": 10,
        "questions": "https://i.ibb.co/4fVh3LK/eq10.jpg",
        "answer": 4
    },
    {
        "id": 11,
        "questions": "https://i.ibb.co/8MBNzPp/mq1.jpg",
        "answer": 4
    },
    {
        "id": 12,
        "questions": "https://i.ibb.co/Mg1sbb3/mq2.jpg",
        "answer": 4
    },
    {
        "id": 13,
        "questions": "https://i.ibb.co/MBM672z/mq3.jpg",
        "answer": 2
    },
    {
        "id": 14,
        "questions": "https://i.ibb.co/VYkPc6y/mq4.jpg",
        "answer": 3
    },
    {
        "id": 15,
        "questions": "https://i.ibb.co/48XcL7r/mq5.jpg",
        "answer": 3
    },
    {
        "id": 16,
        "questions": "https://i.ibb.co/4sXHKqW/mq6.jpg",
        "answer": 1
    },
    {
        "id": 17,
        "questions": "https://i.ibb.co/0nVsn4T/mq7.jpg",
        "answer": 3
    },
    {
        "id": 18,
        "questions": "https://i.ibb.co/vcB5DJ6/mq8.jpg",
        "answer": 4
    },
    {
        id: 19,
        questions: "https://i.ibb.co/BCGCXWk/mq9.jpg",
        answer: 1
    },
    {
        id: 20,
        questions: "https://i.ibb.co/C6j5ZCn/mq10.jpg",
        answer: 3
    },
    {
        id: 21,
        questions: "https://i.ibb.co/p1Xz9cp/hq1.jpg",
        answer: 1
    },
    {
        id: 22,
        questions: "https://i.ibb.co/F5VvH3r/hq2.jpg",
        answer: 3
    },
    {
        id: 23,
        questions: "https://i.ibb.co/nnVWVbj/hq3.jpg",
        answer: 3
    },
    {
        id: 24,
        questions: "https://i.ibb.co/TTwR5P9/hq4.jpg",
        answer: 1
    },
    {
        id: 25,
        questions: "https://i.ibb.co/GHSSLYK/hq5.jpg",
        answer: 2
    },
    {
        id: 26,
        questions: "https://i.ibb.co/kyCKhnh/hq6.jpg",
        answer: 2
    },
    {
        id: 27,
        questions: "https://i.ibb.co/sRbZ05Z/hq7.jpg",
        answer: 2
    },
    {
        id: 28,
        questions: "https://i.ibb.co/gm1RdKw/hq8.jpg",
        answer: 3
    },
    {
        id: 29,
        questions: "https://i.ibb.co/vcVv1MG/hq9.jpg",
        answer: 2
    },
    {
        id: 30,
        questions: "https://i.ibb.co/76YnwYz/hq10.jpg",
        answer: 2
    }
]

function getRandomTenFromArray(arr) {
    let copyArr = [...arr]; // make a copy of the original array to avoid mutating it
    let result = [];
    for (let i = 0; i < 10; i++) {
        let randomIndex = Math.floor(Math.random() * copyArr.length); // generate a random index within the range of the remaining objects in the array
        result.push(copyArr[randomIndex]); // add the randomly selected object to the result array
        copyArr.splice(randomIndex, 1); // remove the selected object from the copy of the array to avoid selecting it again
    }
    return result;
}

export const Questions = getRandomTenFromArray(data);
